<li class="{{class}}">
	<ng-content select="[list-item-top]"></ng-content>
	<a class="{{!link ? 'cursor-default' : ''}}" [attr.href]="href" (click)="onClick($event)">
		<ng-content></ng-content>
	</a>
	<ng-content select="[list-item-bottom]"></ng-content>
</li>